/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;

  .fill, .bg {
    fill: inherit;
  }
`
export default class ToolTipIco extends PureComponent {
  render() {
    return (
      <svg id="정보_버튼" data-name="정보 버튼" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
           css={Color}>
        <g id="정보_버튼-2" data-name="정보 버튼" transform="translate(14 14) rotate(180)">
          <path id="tooltipbg" className="bg" d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Z" fill="#304050"/>
          <path id="i" className="fill"
                d="M13653.076,9701.763a.849.849,0,0,1-.254-.613.874.874,0,1,1,.254.613Zm.146-2.618a.4.4,0,0,1-.4-.4v-4.523a.4.4,0,0,1,.4-.4h.942a.4.4,0,0,1,.4.4v4.523a.4.4,0,0,1-.4.4Z"
                transform="translate(-13646.693 -9690.92)" fill="#eee" stroke="rgba(0,0,0,0)" strokeMiterlimit="10"
                strokeWidth="1"/>
        </g>
      </svg>
    )
  }
}
